/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var framePage = {
  allowSubmit: true,
  facebookAllowSubmit: true
};
/* harmony default export */ __webpack_exports__["a"] = (framePage);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function fireEvent(action) {
  var e = document.createEvent('CustomEvent');
  e.initCustomEvent('acom-track-event', true, true, {
    action: action
  });
  parent.dispatchEvent(e); // The iframe doesn't have the tracking code so we need to dispatch this to the parent.
}

/* harmony default export */ __webpack_exports__["a"] = (fireEvent);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var events = {
  FRAME_RESIZE: 'FRAME_RESIZE',
  // Sends { height }
  SIGNIN_START: 'SIGNIN_START',
  SIGNIN_MALFORMED: 'SIGNIN_MALFORMED',
  // Sends { messages }
  SIGNIN_INVALID_CREDENTIALS: 'SIGNIN_INVALID_CREDENTIALS',
  SIGNIN_ACCOUNT_LOCKED: 'SIGNIN_ACCOUNT_LOCKED',
  SIGNIN_NETWORK_ERROR: 'SIGNIN_NETWORK_ERROR',
  SIGNIN_SERVER_ERROR: 'SIGNIN_SERVER_ERROR',
  SIGNIN_MULTI_ACCOUNT: 'SIGNIN_MULTI_ACCOUNT',
  // Sends { email }
  SIGNIN_MULTI_ACCOUNT_SELECTED: 'SIGNIN_MULTI_ACCOUNT_SELECTED',
  SIGNIN_FACEBOOK_ERROR: 'SIGNIN_FACEBOOK_ERROR',
  SIGNIN_COMPLETE: 'SIGNIN_COMPLETE',
  // Sends { userId, type }
  MFA_START: 'MFA_START',
  MFA_CODE_MALFORMED: 'MFA_CODE_MALFORMED',
  MFA_NETWORK_ERROR: 'MFA_NETWORK_ERROR',
  MFA_SERVER_ERROR: 'MFA_SERVER_ERROR',
  MFA_CODE_INVALID: 'MFA_CODE_INVALID',
  MFA_CODE_EXPIRED: 'MFA_CODE_EXPIRED',
  RECOVERY_CODE_START: 'RECOVERY_CODE_START',
  RECOVERY_CODE_MALFORMED: 'RECOVERY_CODE_MALFORMED',
  RECOVERY_CODE_NETWORK_ERROR: 'RECOVERY_CODE_NETWORK_ERROR',
  RECOVERY_CODE_SERVER_ERROR: 'RECOVERY_CODE_SERVER_ERROR',
  RECOVERY_CODE_INVALID: 'RECOVERY_CODE_INVALID',
  RECOVERY_CODE_COMPLETE: 'RECOVERY_CODE_COMPLETE',
  // Sends { userId }
  RECOVERY_CODE_EXPIRED_CREDENTIALS: 'RECOVERY_CODE_EXPIRED_CREDENTIALS',
  PASSWORD_RESET_START: 'PASSWORD_RESET_START',
  PASSWORD_RESET_NETWORK_ERROR: 'PASSWORD_RESET_NETWORK_ERROR',
  PASSWORD_RESET_SERVER_ERROR: 'PASSWORD_RESET_SERVER_ERROR',
  PASSWORD_RESET_EMAIL_MALFORMED: 'PASSWORD_RESET_EMAIL_MALFORMED',
  PASSWORD_RESET_EMAIL_SENT: 'PASSWORD_RESET_EMAIL_SENT',
  PASSWORD_RESET_SENT: 'PASSWORD_RESET_SENT',
  PASSWORD_RESET_CODE_EXPIRED: 'PASSWORD_RESET_CODE_EXPIRED',
  PASSWORD_RESET_CODE_MALFORMED: 'PASSWORD_RESET_CODE_MALFORMED',
  PASSWORD_RESET_CODE_INVALID: 'PASSWORD_RESET_CODE_INVALID',
  PASSWORD_RESET_CODE_VALID: 'PASSWORD_RESET_CODE_VALID',
  PASSWORD_RESET_CODE_VALID_MULTI_ACCOUNT: 'PASSWORD_RESET_CODE_VALID_MULTI_ACCOUNT',
  PASSWORD_RESET_MULTI_ACCOUNT_SELECTED: 'PASSWORD_RESET_MULTI_ACCOUNT_SELECTED',
  PASSWORD_RESET_PASSWORD_MALFORMED: 'PASSWORD_RESET_PASSWORD_MALFORMED',
  PASSWORD_RESET_PASSWORD_MISMATCH: 'PASSWORD_RESET_PASSWORD_MISMATCH',
  PASSWORD_RESET_PASSWORD_SAVED: 'PASSWORD_RESET_PASSWORD_SAVED'
};
/* harmony default export */ __webpack_exports__["a"] = (events);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global appData */
function sendMessageToParent(event) {
  var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  parent.postMessage({
    event: event,
    detail: detail
  }, "".concat(appData.appPath));
}

/* harmony default export */ __webpack_exports__["a"] = (sendMessageToParent);

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fireEvent__ = __webpack_require__(1);
 // Since we don't want to add the Tealium(utag) tracking to the iframes (because it will double-track with the parent)
// And since the parent page won't receive the click events from the iframes, we need to capture the clicks and fire the events.

function addClickTrackingHandler() {
  document.addEventListener('click', function (a) {
    if (a.target && a.target.dataset.trackClick) {
      var action = a.target.dataset.trackClick;
      Object(__WEBPACK_IMPORTED_MODULE_0__fireEvent__["a" /* default */])(action);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (addClickTrackingHandler);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// taken from https://gist.github.com/nmsdvid/8807205
function debounce(func, wait, immediate) {
  var _this = this;

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var timeout;
  return function () {
    var context = _this;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function redirectIfNotInFrame() {
  if (window.self === window.top) {
    window.location = "".concat(window.appData.appPath, "/signin");
  }
}

/* harmony default export */ __webpack_exports__["a"] = (redirectIfNotInFrame);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__framePage__ = __webpack_require__(0);


function hideLoading($button, extraClasses) {
  __WEBPACK_IMPORTED_MODULE_0__framePage__["a" /* default */].allowSubmit = true;
  $button.addClass(extraClasses).removeClass('loading').removeAttr('aria-busy');
}

/* harmony default export */ __webpack_exports__["a"] = (hideLoading);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__framePage__ = __webpack_require__(0);


function showLoading($button) {
  __WEBPACK_IMPORTED_MODULE_0__framePage__["a" /* default */].allowSubmit = false;
  $button.addClass('loading').attr('aria-busy', true);
}

/* harmony default export */ __webpack_exports__["a"] = (showLoading);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* global $ */
function createAlert(html, insertBeforeLocationQuery) {
  $(html).insertBefore(insertBeforeLocationQuery).alert({
    closeable: true,
    open: false,
    removable: true,
    size: 'slim',
    onOpen: function onOpen($alert) {
      $alert.addClass('signInAlert');
    }
  }).alert('open');
}

/* harmony default export */ __webpack_exports__["a"] = (createAlert);

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_addClickTrackingHandler__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_debounce__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_facebook_facebookSignIn__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_framePage__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_redirectIfNotInFrame__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_submitForm__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_validation_validatorFields__ = __webpack_require__(17);
/* global FB */










(function ($) {
  $(function () {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_redirectIfNotInFrame__["a" /* default */])();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_addClickTrackingHandler__["a" /* default */])();
    Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__utils_events__["a" /* default */].SIGNIN_START);
    var height = $('body').height();
    Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])('FRAME_RESIZE', {
      height: height
    });
    var sendHeightToParent = Object(__WEBPACK_IMPORTED_MODULE_1__utils_debounce__["a" /* default */])(function () {
      var newHeight = $('body').height();

      if (newHeight !== height) {
        height = newHeight;
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])('FRAME_RESIZE', {
          height: height
        });
      }
    }, 20);
    __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$fbSignInBtn = $('#fbSignInBtn');
    __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$password = $('#password');
    __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$signInBtn = $('#signInBtn');
    __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$title = $('#title');
    __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$username = $('#username');
    $.ajaxSetup({
      cache: true
    });
    $.getScript('//connect.facebook.net/en_US/sdk.js', function () {
      var fbInitOptions = {
        appId: __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$fbSignInBtn.data('fbAppId'),
        cookie: true,
        // enable cookies to allow the server to access the session
        xfbml: true,
        // parse social plugins on this page
        version: __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$fbSignInBtn.data('fbGraphApiVersion')
      };
      FB.init(fbInitOptions);
      __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$fbSignInBtn.on('click', function () {
        __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$fbSignInBtn.addClass('loading');
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_facebook_facebookSignIn__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$fbSignInBtn.data('fbPermissions'));
      });
    });
    var $signInForm = $('#signInForm');
    $signInForm.validator({
      allowMultipleSubmissions: true,
      fields: __WEBPACK_IMPORTED_MODULE_8__index_validation_validatorFields__["a" /* default */],
      onSubmit: __WEBPACK_IMPORTED_MODULE_7__index_submitForm__["a" /* default */]
    });
    $signInForm.removeAttr('onsubmit');
    __WEBPACK_IMPORTED_MODULE_4__utils_framePage__["a" /* default */].$username.focus();
    var heightObserver = new MutationObserver(sendHeightToParent);
    heightObserver.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });
    window.addEventListener('resize', sendHeightToParent);
  });
})(jQuery);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__framePage__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sendMessageToParent__ = __webpack_require__(3);
/* global appData, FB, $ */




function facebookSignIn(scope) {
  if (!__WEBPACK_IMPORTED_MODULE_1__framePage__["a" /* default */].facebookAllowSubmit) {
    return false;
  }

  __WEBPACK_IMPORTED_MODULE_1__framePage__["a" /* default */].facebookAllowSubmit = false;
  var fbLoginOptions = {
    auth_type: 'rerequest',
    // use this when re-requesting a declined permission
    return_scopes: true,
    // include 'grantedScopes' field in 'authResponse'
    scope: scope
  };
  FB.login(function (response) {
    if (response.authResponse) {
      $.ajax({
        type: 'POST',
        url: "".concat(appData.appPath, "/signin/frame/facebook"),
        data: {
          accessToken: response.authResponse.accessToken,
          facebookId: response.authResponse.userID
        },
        dataType: 'json',
        success: function success(data) {
          switch (data.status) {
            case 'attCreated':
              {
                Object(__WEBPACK_IMPORTED_MODULE_2__sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* default */].SIGNIN_COMPLETE, {
                  userId: data.userId
                });
                break;
              }

            default:
              {
                Object(__WEBPACK_IMPORTED_MODULE_2__sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* default */].SIGNIN_FACEBOOK_ERROR);
              }
          }
        },
        complete: function complete() {
          __WEBPACK_IMPORTED_MODULE_1__framePage__["a" /* default */].facebookAllowSubmit = true;
          $('#fbSignInBtn').removeClass('loading');
        },
        error: function error(_ref) {
          var status = _ref.status;

          if (status > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_2__sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* default */].SIGNIN_SERVER_ERROR);
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_2__sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* default */].SIGNIN_NETWORK_ERROR);
          }
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_1__framePage__["a" /* default */].facebookAllowSubmit = true;
      $('#fbSignInBtn').removeClass('loading');
    }
  }, fbLoginOptions);
}

/* harmony default export */ __webpack_exports__["a"] = (facebookSignIn);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createAlert__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_fireEvent__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loading_hideLoading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_loading_showLoading__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_framePage__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__ = __webpack_require__(3);
/* global appData, $ */








function enableSubmit() {
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_loading_hideLoading__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].$signInBtn, '');
}

function handleError(status, html) {
  var eventName;

  switch (status) {
    case 'invalidCredentials':
      {
        eventName = 'sign in : failed';
        break;
      }

    case 'accountLocked':
      {
        eventName = 'sign in : failed : account lockout';
        break;
      }

    case 'imsUnknown':
    case 'badRequest':
    default:
      {
        eventName = 'sign in : network error';
      }
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__utils_fireEvent__["a" /* default */])(eventName);
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_createAlert__["a" /* default */])(html, '#validationWrp');
  enableSubmit();
  $('#signInForm').find('input').first().focus();
}

function getValidationMessages($form) {
  var errorMessageElems = $form.find('.errorMessage');
  return errorMessageElems.map(function (index, elem) {
    return {
      field: elem.id.replace('LabelErrorMessage', ''),
      message: $(elem).text()
    };
  }).toArray();
}

function submitForm(valid, $form) {
  // Accessibility - focus the first error
  if (!valid) {
    $form.find('input.error').first().focus();
    Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_MALFORMED, {
      messages: getValidationMessages($form)
    });
  }

  if (!valid || !__WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].allowSubmit) {
    return false;
  }

  $('.signInAlert').alert('close');
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_loading_showLoading__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].$signInBtn);
  var ajaxData = {
    password: __WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].$password.val().trim(),
    username: __WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].$username.val().trim()
  };

  if (__WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].accessToken && __WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].facebookId) {
    ajaxData.accessToken = __WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].accessToken;
    ajaxData.facebookId = __WEBPACK_IMPORTED_MODULE_5__utils_framePage__["a" /* default */].facebookId;
  }

  $.ajax({
    type: 'POST',
    url: "".concat(appData.appPath, "/signin/frame/authenticate"),
    contentType: 'application/json',
    processData: false,
    data: JSON.stringify(ajaxData),
    dataType: 'json',
    success: function success(data) {
      switch (data.status) {
        case 'attCreated':
          {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_fireEvent__["a" /* default */])('sign in : success');
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_COMPLETE, {
              userId: data.userId,
              type: 'standard',
              passwordReset: data.passwordReset
            });
            break;
          }

        case 'multipleUsers':
          {
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_MULTI_ACCOUNT, {
              email: data.email
            });
            $('main.page').addClass('noDisplay');
            $('#accountSelectWrp').removeClass('noDisplay');
            enableSubmit();
            $('#accountSelectForm').get(0).hydrate(data.users);
            $('#accountSelectForm').one('ACCOUNT_SELECTED', function (e, user) {
              $('main.page').removeClass('noDisplay');
              $('#accountSelectWrp').addClass('noDisplay');
              $('#username').val(user.username);
              $('#signInBtn').click();
              Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_MULTI_ACCOUNT_SELECTED);
            });
            break;
          }

        case 'mfa':
          {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_fireEvent__["a" /* default */])('MFA : modal shown');
            var prefix = appData.queryString ? '&' : '';
            window.location = "".concat(appData.appPath, "/signin/frame/mfa?").concat(appData.queryString).concat(prefix, "sms=").concat(data.sms);
            return;
          }

        case 'invalidCredentials':
          {
            $('#username').addClass('error').removeClass('success');
            $('#password').addClass('error').removeClass('success');
            $('#usernameLabel').addClass('error').removeClass('success');
            $('#passwordLabel').addClass('error').removeClass('success');
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_INVALID_CREDENTIALS);
            handleError(data.status, data.html);
            break;
          }

        case 'accountLocked':
          {
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_ACCOUNT_LOCKED);
            handleError(data.status, data.html);
            break;
          }

        case 'badRequest':
        case 'imsUnknown':
        default:
          {
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_SERVER_ERROR);
            handleError(data.status, data.html);
          }
      }
    },
    error: function error(_ref) {
      var status = _ref.status;

      if (status > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_SERVER_ERROR);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_sendMessageToParent__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__utils_events__["a" /* default */].SIGNIN_NETWORK_ERROR);
      }

      handleError();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (submitForm);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var validatorFields = {
  password: {
    required: true,
    errorLocation: 'below',
    pattern: function pattern(sample, $field) {
      if (sample.length === 0) {
        return false;
      }

      if (sample.length < 5) {
        $field.trigger('validation-error-index', [1]);
        return false;
      }

      return true;
    },
    when: 'submit'
  },
  username: {
    required: true,
    errorLocation: 'below',
    pattern: function pattern(sample, $field) {
      if (sample.length === 0) {
        return false;
      }

      if (sample.length < 4) {
        $field.trigger('validation-error-index', [1]);
        return false;
      }

      if (!/^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÄËÏÖÜçÇßøØåÅæÆþÞðÐ\d\s'.,-@_+]{4,64}$/.test(sample)) {
        $field.trigger('validation-error-index', [2]);
        return false;
      }

      return true;
    },
    when: 'submit'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (validatorFields);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/signin/frame/index.js